import { IApplicationState } from '../../types/redux';

export const listingUrlSelector = (state: IApplicationState) => {
  return state.promoOffersSelection.listingUrl;
};
